<template>
    <div class="container-fluid">
        <nav>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/mypage">マイページ</router-link></li>
                <li class="breadcrumb-item">送った感想</li>
            </ol>
        </nav>
        <div class="container">
            <div class="row">
                <div class="col-lg-4 pt-4 mt-4">
                    <div>
                        <h6>感想は作者にしか見えません</h6>
                        <p>
                            感想は投稿した本人と、作者にしか見えません。
                            第三者に表示されることはありません。
                            そのためネタバレや他の読者に読まれて困る内容の感想も、安心して受け取ることができます。
                        </p>
                        <h6>返信を貰えることがあります</h6>
                        <p>
                            送った感想に作者から返信を貰えることがありますが、必ず貰えるものではありません。
                            作者の諸事情で返信を控えていることや、執筆に時間を割いていて返信できないことがあります。
                            感想の中で、返信を要求することはお控えください。
                        </p>
                        <h6>ガイドライン違反は通報されることがあります</h6>
                        <p>
                            作品と無関係な私信、誹謗中傷、宣伝行為などはガイドラインで禁じられています。
                            こうした内容を感想機能で送らないようにしてください。
                        </p>
                    </div>
                </div>
                <div class="col-lg-8">
                    <div class="sticky">
                        <page :last_page="reviews.last_page" v-model="page" @goto="goto"></page>
                    </div>
                    <div v-if="reviews.total">
                        <div class="review" v-for="r in reviews.data" :key="r.id">
                            <div class="book b-light mincho" v-if="r.book">
                                <h5 v-html="$filters.ruby(r.book.title)"></h5>
                                <h6 v-if="r.book.subtitle">{{r.book.subtitle}}</h6>
                                <h6>
                                    <ruby>{{r.book.user.name}}<rt>{{r.book.user.kana}}</rt></ruby>
                                </h6>
                            </div>
                            <div class="book b-light mincho" v-else>
                                小説が削除されました。
                            </div>
                            <div>
                                <div v-if="r.applause">
                                    <span class="badge badge-pills badge-info">
                                        <h6 class="m-0">{{r.applause.caption}}</h6>
                                    </span>
                                </div>
                                <div class="review-item mincho" v-html="$filters.wrap(r.body)"></div>
                                <div class="reply mincho" v-html="$filters.wrap(r.reply)" v-if="r.reply"></div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="nothing">
                        投稿した感想はありません。
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.review {
    margin: 1rem 0;
    padding: 1rem 0;
    border-bottom: 1px solid #ddd;
    .book {
        text-align: center;
        padding: 1rem 0 .5rem;
        margin: .5rem 0;
        border-radius: .5rem .5rem 0 0;
    }
    .review-item {
        font-size: 1.1rem;
        padding: .5rem .5rem 1rem;
    }
    .reply {
        border-top: 1px dashed #ddd;
        padding: 1rem;
    }
}
</style>

<script>
import page from "components/Page";
export default {
    components: {
        page,
    },
    data() {
        return {
            reviews: [],
            page: 1,
            routeWathcer: null,
        }
    },
    methods: {
        goto(p) {
            this.page = p;
            setTimeout(() => {this.load()});
        },
        load() {
            $("html,body").animate({scrollTop: 0}, 300);
            axios.get("/mypage/reviews/sent/get", {params: {
                page: this.page
            }}).then(res => {
                this.reviews = res.data;
            }).catch(err => {
                alert.err(err.response);
            });
        },
    },
    mounted() {
        this.load();
        this.routeWatcher = this.$watch('$route', (o, n) => {
            this.reviews = [];
            this.load();
        });
        setTimeout(() => {
            this.useHead({
                title: "投稿した感想 | 貸し本棚",
                link: [ { rel: "canonical", href: location.origin + location.pathname, id: "canonical" } ],
                meta: [
                    { name: "keywords", content: "貸し本棚,小説投稿,Web小説,小説展示,オンライン小説,縦書き小説,置き場,文芸,ライトノベル", id: "meta-keywords" },
                    { name: "description", content: "小説を書くこと、読むことにフォーカスした小説投稿サイトです。作家さん独自のサブドメインで、ご自身の小説を公開できます。横断的に編集ができるエディタで原稿執筆することも、過去の作品をレーティングを気にせず展示することもできます。", id: "meta-description" }
                ]
            });
        }, 1000);
    },
    beforeRouteLeave(to, from) {
        this.reviews = [];
        this.load();
    }
}
</script>